// Formatting for the staff cost pages.

/** "$1,204.50"; amounts under a dollar keep their cents, and tiny ones their fractions ("$0.0042"). */
export function money(amount: number | null | undefined, digits = 2): string {
  if (amount === null || amount === undefined || !Number.isFinite(amount)) return 'Not known';
  const small = amount !== 0 && Math.abs(amount) < 0.01;
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: small ? 4 : digits,
    maximumFractionDigits: small ? 4 : digits,
  });
}

/** "2026-10" -> "October 2026" */
export function monthLabel(month: string): string {
  const [year, number] = month.split('-').map(Number);
  if (!year || !number) return month;
  return new Date(Date.UTC(year, number - 1, 1)).toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}

/** "2026-10" -> "Oct" */
export function shortMonth(month: string): string {
  const [year, number] = month.split('-').map(Number);
  if (!year || !number) return month;
  return new Date(Date.UTC(year, number - 1, 1)).toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
}

export function count(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString('en-US');
}

/** 319.4 -> "319 MB"; 2048 -> "2.0 GB" */
export function megabytes(mb: number | null | undefined): string {
  if (mb === null || mb === undefined) return 'Not known';
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${Math.round(mb)} MB`;
}

const FEATURE_LABELS: Record<string, string> = {
  tailored_resume: 'Tailored resumes',
  resume_parse: 'Reading resumes into facts',
  email_classification: 'Classifying employer emails',
};

export function featureLabel(feature: string): string {
  return FEATURE_LABELS[feature] ?? feature.replace(/_/g, ' ');
}

export const PERIOD_LABELS: Record<string, string> = {
  monthly: 'Every month',
  yearly: 'Every year',
  one_off: 'One-off',
};
